// Build-time feature flags.
//
// Vite statically replaces `import.meta.env.VITE_*` values at build time, so
// a disabled flag turns its guarded code into dead branches. The flagged
// feature ships (or doesn't) per build without commenting code in and out.
//
// Flip a flag by editing .env (all modes) or overriding in .env.local for
// your own machine only (gitignored; `yarn dev` picks it up on restart).

// Ask BowVue, the AI assistant: the floating chat widget (layouts/main.vue)
// and the /ask-bowvue route (router/routes.js). Disabled for the production
// launch. Set VITE_FF_ASK_BOWVUE=true in .env to relaunch it everywhere.
export const ASK_BOWVUE_ENABLED = import.meta.env.VITE_FF_ASK_BOWVUE === 'true'

// Legacy Infrared: the /legacy-infrared route (router/routes.js) plus its two
// nav entries (components/nav-bar.vue and router/layouts/main.vue).
//
// Turned OFF 2026-08-11. The page reads the `legacy_ir` schema, which is a
// point-in-time copy taken 2026-08-06. On 2026-08-11 the retired Rails system
// was brought back online and staff resumed entering data into it, so that copy
// is now a stale fork rather than the record, presenting it as history would
// actively mislead.
//
// The data is untouched; only the way in is removed. To turn back on, set
// VITE_FF_LEGACY_INFRARED=true and rebuild, but re-import first (see
// bowvue-graphql deploy/legacy_ir_import.sh) or the page resumes lying.
export const LEGACY_INFRARED_ENABLED =
  import.meta.env.VITE_FF_LEGACY_INFRARED === 'true'
